import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, AbstractControl } from '@angular/forms';
import { MatSelect } from '@angular/material/select';
import { Subscription } from 'rxjs';
import { ServiceDeliveryService } from 'src/app/component/children/service-delivery/service/service-delivery.service';
import { ServiceCategories } from '../model/service-categories.model';

@Component({
    selector: 'service-category-dropdown',
    templateUrl: './service-category-dropdown.component.html',
    styleUrls: ['./service-category-dropdown.component.scss']
})
export class ServiceCategoryDropdownComponent implements OnInit {
    @Input() label: string = '';
    @Input() isMultiple: boolean = false;
    @Input() required: boolean = false;
    @Input() disabled: boolean = false;

    @Input('reset') reset: boolean;
    @Output() serviceCategoryEvent = new EventEmitter<ServiceCategories[]>();

    serviceCategories: ServiceCategories[] = [];
    filteredServiceCategories: ServiceCategories[] = [];

    form: UntypedFormGroup;
    @ViewChild(MatSelect) matSelect: MatSelect;

    subs: Subscription[] = [];

    isLoading: boolean = false;

    constructor(private serviceDeliveryService: ServiceDeliveryService, private fb: UntypedFormBuilder) {
        this.form = this.fb.group({
            serviceCategorySelect: [[]]
        });

        this.getServiceCategories();
        this.subscribers();
    }

    ngOnInit(): void {}

    subscribers() {
        let serviceSelectSub = this.serviceCategorySelect.valueChanges.subscribe((serviceCategories: ServiceCategories[]) => {
            this.serviceCategoryEvent.emit(serviceCategories);
        });
        this.subs.push(serviceSelectSub);
    }

    ngOnChanges(): void {
        if (this.reset) {
            this.resetFunction();
        }

        if (this.disabled) {
            this.serviceCategorySelect.disable();
        } else {
            this.serviceCategorySelect.enable();
        }
    }

    ngOnDestroy() {
        this.subs.forEach((sub) => {
            sub.unsubscribe();
        });
    }

    getServiceCategories() {
        this.isLoading = true;
        this.serviceDeliveryService.getServiceCategory().subscribe((res) => {
            if (res.result) {
                this.serviceCategories = res.result.sort((a: any, b: any) => a.CATEGORY.toString()!.localeCompare(b.CATEGORY.toString()!));

                this.filteredServiceCategories = this.serviceCategories;
            } else {
            }

            this.isLoading = false;
        });
    }

    get serviceCategorySelect(): AbstractControl {
        return this.form.get('serviceCategorySelect')!;
    }

    selectAll(type?: string) {
        if (this.isMultiple) {
            this.serviceCategorySelect.patchValue(this.filteredServiceCategories);
        }
    }

    deSelectAll() {
        this.reset = false;
        this.serviceCategorySelect.patchValue([]);

        if (!this.isMultiple) {
            this.close();
        }
    }

    close() {
        this.matSelect.close();
    }

    resetFunction() {
        this.serviceCategorySelect.setValue([]);
        this.serviceCategoryEvent.emit([]);
        this.reset = false;
    }

    get schoolSelect(): any {
        return this.form.get('serviceCategorySelect');
    }

    onOpen(opened: boolean) {}
}
